module.exports = {"320113001":"尧化街道","320113002":"马群街道","320113003":"迈皋桥街道","320113004":"燕子矶街道","320113005":"栖霞街道","320113006":"龙潭街道","320113007":"仙林街道","320113009":"八卦洲街道","320113010":"西岗街道","320113400":"龙潭监狱","320113401":"栖霞经济开发区","320113402":"南京龙潭物流园","320113403":"南京市靖安三江口工业园","320113405":"南京市马群科技园","320113406":"南京仙林大学城","320113407":"江苏生命科技创新园","320113409":"南大科学园","320113410":"南京紫东国际创意园","320113411":"南京金港科技创业中心","320113413":"仙林智谷","320113450":"南京经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320113.json
// module id = 930
// module chunks = 0